<template>
    <div class="app-container" :style="minHeight">
      <div style="width:100%;margin:0 auto;overflow:hidden;position:relative;height:100%;">
        <!-- 使用 v-show 确保 iframe 始终在 DOM 中 -->
        <div v-for="(item) in cachedIframes"
             v-show="activePath === item.path"
             :key="item.path"
             class="iframe-wrapper">
          <iframe
            :ref="el => setIframeRef(item.path, el)"
            :src="item.iframeUrl"
            frameborder="0"
            scrolling="yes"
            style="width:100%;height:100%;border:none;"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { bus } from '../../../../utils/bus';
  export default {
    name: 'BiReport',
    // 添加路由变化检测，确保组件复用
    beforeRouteUpdate(to, from, next) {
      // 手动处理路由更新
      this.activePath = to.path;
      this.handleRouteChange(to);
      next();
    },
    data() {
      return {
        minHeight: '',
        activePath: '',
        cachedIframes: [],
        iframeRefs: {},
        iframeLoaded: {}
      };
    },
    watch: {
      // 监听路由变化（首次加载时）
      '$route': {
        immediate: true,
        handler(newRoute) {
          this.activePath = newRoute.path;
          this.handleRouteChange(newRoute);
        }
      }
    },
    // 使用 mounted 替代 created，确保只执行一次
    mounted() {
      this.initComponent();
      window.addEventListener('resize', this.updateHeight);
      window.addEventListener('beforeunload', this.cleanSessionStorage);
      bus.$on('DEL_IFRAME_VIEW', function(value) {
        this.cachedIframes = value;
      });
    },
    beforeDestroy() {
      this.cleanSessionStorage(); // 避免从非iframe页面切回时 一次性加载全部缓存iframe
      window.removeEventListener('resize', this.updateHeight);
      window.removeEventListener('beforeunload', this.cleanSessionStorage);
      bus.$off('DEL_IFRAME_VIEW');
    },
    methods: {
      // 初始化组件（只执行一次）
      initComponent() {
        this.updateHeight();
        this.loadCachedIframes();
      },
      // 更新高度
      updateHeight() {
        const h = document.documentElement.clientHeight - 100;
        this.minHeight = `height:${h}px;`;
      },
      cleanSessionStorage() {
        sessionStorage.removeItem('cachedIframes');
      },
      // 设置iframe引用
      setIframeRef(path, el) {
        if (el) {
          this.iframeRefs[path] = el;
          if (this.iframeLoaded[path]) {
            this.showIframe(path);
          } else {
            el.onload = () => {
              this.iframeLoaded[path] = true;
              this.showIframe(path);
            };
          }
        }
      },
      // 显示iframe内容
      showIframe(path) {
        if (this.iframeRefs[path]?.contentDocument) {
          this.iframeRefs[path].contentDocument.body.style.visibility = 'visible';
        }
      },
      // 从sessionStorage加载缓存
      loadCachedIframes() {
        const cache = sessionStorage.getItem('cachedIframes');
        if (cache) {
          try {
            this.cachedIframes = JSON.parse(cache);
            this.cachedIframes.forEach(item => {
              this.iframeLoaded[item.path] = false;
            });
          } catch (e) {
            console.error('解析缓存失败:', e);
            this.cachedIframes = [];
          }
        }
      },
      // 保存缓存到sessionStorage
      saveCachedIframes() {
        sessionStorage.setItem('cachedIframes', JSON.stringify(this.cachedIframes));
      },
      // 处理路由变化
      handleRouteChange(route) {
        const path = route.path;
        const iframeUrl = route.meta?.iframeUrl || '';
  
        if (!iframeUrl) return;
  
        // 确保加载最新缓存
        this.loadCachedIframes();
  
        const exists = this.cachedIframes.some(item => item.path === path);
  
        if (!exists) {
          const newCache = [
            ...this.cachedIframes,
            {
              path,
              iframeUrl,
              title: route.meta?.title || '',
              lastAccess: Date.now()
            }
          ];
  
          this.cachedIframes = newCache;
          this.saveCachedIframes();
          this.iframeLoaded[path] = false;
        } else {
          this.cachedIframes = this.cachedIframes.map(item =>
            item.path === path ? {...item, lastAccess: Date.now()} : item
          );
          this.saveCachedIframes();
  
          if (this.iframeLoaded[path]) {
            this.$nextTick(() => this.showIframe(path));
          }
        }
  
        this.activePath = path;
      }
    }
  };
  </script>
  
  <style scoped>
  .iframe-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  </style>
  